module.exports = __webpack_public_path__ + "static/img/4005.0534a6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4005.png
// module id = 712
// module chunks = 0 1 12